(function () {
  angular.module("akitabox.ui.dialogs.qrConfirmAssign", [
    "ngMaterial",
    "akitabox.core.services.qrcode",
    "akitabox.core.toast",
  ]);
})();
